import { useEffect, useState } from "react";
import { PubDetail } from "../../../../api/cafe";
import {
  PointDistributionDetail,
  SeedDistributionDetail,
} from "../../../../api/tournament-prize";
import { SettlementTournament } from "../../../../api/settlement";
import { SolutionTableWrapper, PageContentHeader } from "../../style";
import {
  SolutionListWrapper,
  SolutionTableContent,
  SolutionTableHeader,
  SolutionTableItem,
} from "./style";
import { PaginationWrapper } from "../../../../component/CommonTable";
import PopupPagination from "../../../../component/Pagination/popupPagination";
import { getSeedPaymentHistory } from "../../../../api/settlement";
import * as ExcelJS from "exceljs";
import {
  getTournamentTypeName,
  isEventType,
} from "../../../../utils/tournament-type";
import { exchangePoint } from "../../../../utils/number";

interface SolutionTableProps {
  allList: SettlementTournament[];
  pub: PubDetail | null;
  handlePointPaidPopup: (item: SettlementTournament) => void;
  handleTournamentPopup: (item: SettlementTournament) => void;
}
export const SolutionTable = ({
  allList,
  pub,
  handlePointPaidPopup,
  handleTournamentPopup,
}: SolutionTableProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [list, setList] = useState<SettlementTournament[]>([]);

  useEffect(() => {
    setList(allList.slice((currentPage - 1) * 10, currentPage * 10));
    setTotalPage(Math.max(1, Math.ceil(allList.length / 10)));
  }, [allList, currentPage]);

  const onPageChange = async (nextPage: number) => {
    setCurrentPage(nextPage);
  };

  const getResultPoint = (item: PointDistributionDetail[]) => {
    if (!pub) return 0;
    let point = 0;
    item.map((item) => (point += item.resultPoints));

    return exchangePoint(point);
  };

  const getResultSeed = (item: SeedDistributionDetail[]) => {
    if (!pub) return 0;
    let seed = 0;
    item.map((item) => (seed += item.resultSeeds));

    return seed;
  };

  const getIsPointPaid = (item: SettlementTournament) => {
    return item.totalMoneyInCount !== item.seedDistributionDetails.length;
  };

  const getSeedPaymentHistoryList = async (tournamentId: number) => {
    const response = await getSeedPaymentHistory(tournamentId);

    if (response.length === 0) {
      alert("래빗 결제 내역이 존재하지 않습니다.");
      return;
    }
    // 엑셀 파일 생성 및 다운로드
    await downloadExcel(response, tournamentId);
  };

  const downloadExcel = async (data: any[], tournamentId: number) => {
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("크레딧 결제 내역");

      // 헤더 설정
      worksheet.columns = [
        { header: "결제일시", key: "createdAt", width: 20 },
        { header: "닉네임", key: "nickname", width: 15 },
        { header: "수량", key: "amount", width: 12 },
      ];

      // 헤더 스타일 설정
      worksheet.getRow(1).font = { bold: true };
      worksheet.getRow(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE6E6FA" },
      };

      // 데이터 추가
      data.forEach((item) => {
        worksheet.addRow({
          createdAt: new Date(item.createdAt).toLocaleString("ko-KR"),
          nickname: item.nickname,
          amount: item.amount,
        });
      });

      // 엑셀 파일 생성 및 다운로드
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `크레딧_결제_내역_${tournamentId}_${
        new Date().toISOString().split("T")[0]
      }.xlsx`;
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("엑셀 다운로드 실패:", error);
      alert("엑셀 다운로드에 실패했습니다.");
    }
  };

  const columns = [
    { header: "", className: "no" },
    { header: "종류", className: "type" },
    { header: "토너먼트 이름", className: "title" },
    { header: "엔트리", className: "no" },
    { header: "시작 시간", className: "time" },
    {
      header: "사용/지급 매장 이용권",
      className: "price",
    },
    {
      header: "사용/지급 크레딧",
      className: "price",
    },
    { header: "", className: "button" },
    { header: "", className: "button min" },
    { header: "", className: "button" },
  ];

  return (
    <SolutionTableWrapper className="box5">
      <PageContentHeader>
        <div className="title">오늘의 토너먼트</div>
      </PageContentHeader>
      {list.length === 0 ? (
        <div className="length">정산할 토너먼트가 존재하지 않습니다.</div>
      ) : (
        <SolutionTableContent>
          <SolutionTableHeader>
            {columns.map((item, index) => (
              <div key={index} className={`item ${item.className}`}>
                {item.header}
              </div>
            ))}
          </SolutionTableHeader>
          <SolutionListWrapper>
            {list.map((item, index) => (
              <SolutionTableItem key={index}>
                <div className="item no">{index + 1}</div>
                <div className="item type">
                  {getTournamentTypeName(item.tournamentType)}
                </div>
                <div className="item title">
                  <span>{item.title}</span>
                </div>
                <div className="item no">
                  {item.entryCount}
                  {item.notCountAddon > 0 && `(${item.notCountAddon})`}
                </div>
                <div className="item time">{item.startDate.split(" ")[1]}</div>
                <div className="item price">
                  {exchangePoint(item.usedPoint)} /{" "}
                  {getResultPoint(item.distributionDetails)} E
                </div>
                <div className="item price">
                  {item.usedSeed.toLocaleString()} /{" "}
                  {getResultSeed(item.seedDistributionDetails)}
                </div>
                <div
                  className="item button"
                  onClick={() => handleTournamentPopup(item)}
                >
                  <span>자세히 보기</span>
                </div>
                <div className="item button min">
                  {!isEventType(item.tournamentType) && (
                    <span
                      style={{
                        background: getIsPointPaid(item)
                          ? "#7F25FB"
                          : "#969696",
                      }}
                      onClick={() => handlePointPaidPopup(item)}
                    >
                      {getIsPointPaid(item) ? `시상` : `시상 완료`}
                    </span>
                  )}
                </div>
                <div className="item button">
                  <span
                    onClick={async () =>
                      await getSeedPaymentHistoryList(item.tournamentId)
                    }
                  >
                    크레딧 결제 내역
                  </span>
                </div>
              </SolutionTableItem>
            ))}
          </SolutionListWrapper>
        </SolutionTableContent>
      )}
      {totalPage > 1 && (
        <PaginationWrapper>
          <PopupPagination
            currentPage={currentPage}
            totalPages={totalPage}
            onPageChange={onPageChange}
          />
        </PaginationWrapper>
      )}
    </SolutionTableWrapper>
  );
};
